import { ModalSheet } from './modal-sheet';
import Phaser from 'phaser';
import { ModalSheetConfig } from './modal-sheet/modal-sheet.types';

export class RulesSheet<TemplateData> extends ModalSheet<TemplateData> {
  constructor(
    scene: Phaser.Scene,
    config: ModalSheetConfig<TemplateData> = {},
  ) {
    super(scene, { ...config, iconKey: 'rules' });
  }

  protected createContent(content: Phaser.GameObjects.Container): void {
    const element = this.createDomContent('rules', this.cfg.templateData);
    content.add([element]);
  }
}
